import {orderBy} from 'lodash'
import {CommercialOfferIcon, HrIcon, StatisticsIcon} from './icon'

const HR = 'HR'

const menuList = [
  {
    id: 9,
    icon: 'crm',
    title: 'CRM',
    route: 'ContactsList',
    access: 'crm',
    submenu: [
      {
        id: '9.1',
        title: 'Clients tracking lists',
        route: 'ContactsTrackingLicense',
        access: 'clientTrackingList'
      },
      {
        id: '9.2',
        title: 'List of projects',
        route: 'ListOfProjects',
        access: 'listOfProjects'
      },
      {
        id: '9.3',
        title: 'List of requests',
        route: 'ListOfRequests',
        access: 'listOfRequests'
      }
    ]
  },
  {
    id: 10,
    iconComponent: CommercialOfferIcon(),
    title: 'Commercial offers',
    route: 'MainPageCommercialOffers',
    access: 'commercialoffers'
  },
  {
    id: 1,
    iconComponent: HrIcon(),
    title: HR,
    access: 'hr',
    submenu: [
      {
        id: '1.1',
        title: 'Employees List',
        route: 'EmployeesList',
        access: 'EmployeesList',
        path: '/employees-list'
      },
      {
        id: '1.2',
        title: 'Documents List',
        route: 'DocumentsList',
        access: 'DocumentsList',
        path: '/documents-list'
      },
      {
        id: '1.3',
        title: 'Timeoff',
        route: 'TimeOff',
        access: 'TimeOff',
        path: '/time-off'
      },
      {
        id: '1.4',
        title: 'Assets',
        route: 'AssetsList',
        access: 'AssetsList',
        path: '/assets-list'
      }
    ]
  },
  {
    id: 2,
    icon: 'share',
    title: 'Dissemination',
    route: 'Dissemination',
    access: 'dissemination',
    submenu: [
      {
        id: '2.1',
        title: 'Promotion & Marketing',
        route: 'DisseminationPromotion',
        access: 'promotionMarketing'
      },
      {
        id: '2.2',
        title: 'Publications & PR',
        route: 'DisseminationPublications',
        access: 'publicationsPR'
      },
      {
        id: '2.3',
        title: 'Sales & CRM',
        route: 'DisseminationSales',
        access: 'salesCRM'
      }
    ]
  },
  {
    id: 3,
    icon: 'tool',
    title: 'Services',
    route: 'Services',
    access: 'services',
    submenu: [
      {
        id: '3.1',
        title: 'Interns',
        route: 'ServicesInterns',
        access: 'interns'
      },
      {
        id: '3.2',
        title: 'Project Management',
        route: 'ServicesProjectManagement',
        access: 'projectManagement'
      },
      {
        id: '3.3',
        title: 'Business Consulting',
        route: 'ServicesBusinessConsulting',
        access: 'businessConsulting'
      }
    ]
  },
  {
    id: 4,
    icon: 'money-bag',
    title: 'Finance',
    route: 'Dashboard',
    access: 'finance',
    submenu: [
      {
        id: '4.3',
        title: 'Assets materials records',
        route: 'FinanceAssetsMaterialsRecords',
        access: 'assetsMaterialsRecords'
      },
      {
        id: '4.2',
        title: 'Expenses',
        route: 'FinanceExpenses',
        access: 'expenses'
      },
      {
        id: '4.4',
        title: 'Funds',
        route: 'Funds',
        access: 'assets'
      },
      {
        id: '4.1',
        title: 'Income',
        route: 'FinanceIncome',
        params: {tab: 'invoice-tracking'},
        access: 'income'
      },
      {
        id: '4.5',
        title: 'KPIs',
        route: 'FinanceKPI',
        access: 'kpi'
      },
      {
        id: '4.6',
        title: 'CFO',
        route: 'TotalListOfProjects',
        access: 'finance',
        hideAccessUser: true
      },
      {
        id: '4.7',
        title: 'Services',
        route: 'SettingsServices',
        access: 'financeServices',
      },
    ]
  },
  {
    id: 5,
    icon: 'medal',
    title: 'Qualifications',
    route: 'Qualifications',
    access: 'qualifications',
    submenu: [
      {
        id: '5.1',
        title: 'Quality Control',
        route: 'QualificationsControl',
        access: 'qualityControl'
      },
      {
        id: '5.2',
        title: 'Education & Academy',
        route: 'AcademyEducation',
        access: 'educationAcademy',
        path: '/academy'
      },
      {
        id: '5.3',
        title: 'Wiki',
        route: 'WikiAllSpacesPage',
        access: 'wiki',
        path: '/wiki'
      },
      {
        id: '5.4',
        title: 'Certifications & Awards',
        route: 'QualificationsCertifications',
        access: 'certificationsAwards'
      }
    ]
  },
  {
    id: 6,
    icon: 'rocket',
    title: 'Business Development',
    route: 'BusinessDevelopment',
    access: 'businessDevelopment',
    submenu: [
      {
        id: '6.1',
        title: 'Partners and Referrals',
        route: 'BusinessDevelopmentPartners',
        access: 'partnersAndReferals'
      },
      {
        id: '6.2',
        title: 'Business Clubs & Associations',
        route: 'BusinessDevelopmentClubs',
        access: 'businessClubsAssociacions'
      },
      {
        id: '6.3',
        title: 'Public Information & Service',
        route: 'BusinessDevelopmentService',
        access: 'publicInformationService'
      }
    ]
  },
  {
    id: 7,
    icon: 'clerk',
    title: 'Executive',
    route: 'Executive',
    access: 'executive',
    submenu: [
      {
        id: '7.1',
        title: 'Office of Founder',
        route: 'ExecutiveFounder',
        access: 'officeOfFounder'
      },
      {
        id: '7.2',
        title: 'Office of Corp Affairs',
        route: 'ExecutiveCorpAffairs',
        access: 'officeOfCorpAffairs'
      },
      {
        id: '7.3',
        title: 'Office of the CEO',
        route: 'ExecutiveCEO',
        access: 'officeOfTheCEO'
      }
    ]
  },
  {
    id: 12,
    iconComponent: StatisticsIcon(),
    title: 'Statistics',
    access: 'statistics',
    submenu: [
      {
        id: '12.1',
        title: 'Execution Department (12)',
        route: 'ExecutionDepartment',
        access: 'executionDepartment12',
        path: '/statistics/execution-department'
      }
    ]
  },
  {
    id: 8,
    icon: 'settings',
    title: 'Settings',
    submenu: [
      {
        id: '8.1',
        title: 'Users',
        route: 'SettingsUsers'
      },
      {
        id: '8.2',
        title: 'Company',
        titleFounder: 'Companies',
        route: 'SettingsCompanies'
      },
      {
        id: '8.3',
        title: 'Positions',
        route: 'SettingsPosition'
      },
      {
        id: '8.4',
        title: 'Bank details',
        route: 'SettingsBankDetails'
      },
      {
        id: '8.5',
        title: 'Categories Settings',
        route: 'SettingsExpenseCategories'
      },
      {
        id: '8.6',
        title: 'Logs',
        route: 'SettingsLogs'
      },
      {
        id: '8.7',
        title: 'Technical support',
        route: 'TechnicalSupport'
      },
      {
        id: '8.8',
        title: 'Email Statistics',
        route: 'EmailStats'
      },
      {
        id: '8.9',
        title: 'Tags',
        route: 'Tags'
      },
      {
        id: '8.10',
        title: 'Academy',
        route: 'AcademySettings',
        path: '/academy-settings'
      },
    ]
  }
]

export const menu = menuList.map(elemMenu => {
  if (elemMenu.title === HR) return elemMenu
  elemMenu.submenu = orderBy(elemMenu.submenu, ['title'], ['acs'])
  return elemMenu
})



// WEBPACK FOOTER //
// ./src/constants/menu.js